import { createTheme, ThemeOptions } from "@mui/material/styles";
import variable from "./variable.scss";
import { ColorMode } from "../ColorModeContext";

const components: ThemeOptions["components"] = {
  MuiButtonBase: {
    defaultProps: {
      // Skip 300ms / hover-first behavior on iPad so one tap fires click.
      disableRipple: false,
      disableTouchRipple: false,
    },
  },
  MuiMenu: {
    defaultProps: {
      // First tap on iPad/iPhone was only focusing the menu, so date
      // filters, row actions, and print needed a second tap.
      disableAutoFocusItem: true,
      disableEnforceFocus: true,
      disableRestoreFocus: true,
    },
  },
  MuiPopover: {
    defaultProps: {
      disableRestoreFocus: true,
      disableEnforceFocus: true,
    },
  },
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        transition: "background-color 0.2s ease, color 0.2s ease",
      },
    },
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: variable.colorPrimary,
    },
    secondary: {
      main: variable.colorSecondary,
    },
    background: {
      default: variable.bodyBg,
      paper: "#ffffff",
    },
  },
  components,
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#4c7dff",
    },
    secondary: {
      main: "#c5cdd4",
    },
    background: {
      default: "#121212",
      paper: "#1c1c1e",
    },
    text: {
      primary: "#f5f5f5",
      secondary: "#c8c8c8",
    },
    divider: "#2e2e32",
  },
  components,
});

export const getAppTheme = (mode: ColorMode) =>
  mode === "dark" ? darkTheme : lightTheme;